export const isHex = /^\s*#?[0-9A-F]{6}\s*$/i;
export const isShortHex = /^\s*#?[0-9A-F]{3}\s*$/i;
